import script from "./name-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./name-picker.vue?vue&type=script&setup=true&lang=ts"

import "./name-picker.vue?vue&type=style&index=0&id=78ed36eb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ed36eb"]])

export default __exports__